import React, { PureComponent } from 'react';
import { PRODUCT_LIST_TYPE, UserProductGroup } from '~/Api/User/ProductGroup';
import { SelectModal as ExchangeRateSelectModal } from '~/ExchangeRate';
import { CreateModal as ProductGroupCreateModal } from '~/ProductGroup';
import ProductGroupDeleteModal from '~/ProductGroupDeleteModal';
import ProductGroupRenameModal from '~/ProductGroupRenameModal';

export type Name = 'rename' | 'delete' | 'create' | 'copy' | 'exchangeRate';
export enum Names {
	rename = 'rename',
	delete = 'delete',
	create = 'create',
	copy = 'copy',
	exchangeRate = 'exchangeRate',
}
interface Props {
	name: Name;
	group: UserProductGroup;
	onClose(): void;
	onDelete(group: UserProductGroup): void;
	onCreate(): void;
}

export default class Modal extends PureComponent<Props> {
	private handleOnClose = (_: UserProductGroup): Promise<{ moduleError: string | null }> => {
		this.props.onClose?.();

		return Promise.resolve({ moduleError: null });
	};

	render() {
		const { name, group, onClose, onDelete, onCreate } = this.props;

		if (name === 'rename') {
			return <ProductGroupRenameModal group={group} onClose={onClose} onSave={this.handleOnClose} />;
		}
		if (name === 'delete') {
			return <ProductGroupDeleteModal group={group} onClose={onClose} onConfirm={() => onDelete(group)} />;
		}
		if (name === 'create') {
			return (
				<ProductGroupCreateModal
					groupType={PRODUCT_LIST_TYPE}
					parentId={group.id}
					onClose={onClose}
					onSave={() => {
						onClose();
						onCreate();
					}}
				/>
			);
		}
		if (name === 'copy') {
			return (
				<ProductGroupCreateModal groupType={group.type} templateGroup={group} onClose={onClose} onSave={onClose} />
			);
		}
		if (name === 'exchangeRate') {
			return <ExchangeRateSelectModal group={group} initiallySelectedDate={null} onClose={onClose} />;
		}
		return null;
	}
}
